import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "twitter-x-circled",
  "use": "twitter-x-circled-usage",
  "viewBox": "0 0 256 256",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 256 256\" id=\"twitter-x-circled\"><path d=\"m24.9 23 32.9 44h7.4L32.3 23z\" transform=\"matrix(2.81 0 0 2.81 1.4 1.4)\" /><path d=\"M45 0a45 45 0 1 0 0 90 45 45 0 1 0 0-90zm11 70.5-15-20-18.5 20h-4.7l21.1-22.9-21-28.1H34l13.8 18.4 17-18.4h4.8L50 40.8l22.2 29.7H56z\" transform=\"matrix(2.81 0 0 2.81 1.4 1.4)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol